<script>
  import { mapGetters } from 'vuex'
  import bus from '@/utils/eventBus'
  import { isMobile } from 'mobile-device-detect'

  export default {
    name: 'menu-aside',
    data () {
      return {
        show: false,
        mobile: false,
        menu: 'dashboard'
      }
    },
    methods: {
      closeMenuMobile (label, sub = false) {
        if (label !== undefined) {
          this.menu = label
        }
        if (!sub) {
          bus.$emit('open-menu-mobile', {show: false})
          /** emitindo evento apos clique na selecao do menu */
          bus.$emit('siderbar-open-menu-mobile', {show: false})
        }
      }
    },
    mounted () {
      if (isMobile) {
        this.mobile = false
      }
      if (!isMobile) {
        this.mobile = true
      }

      bus.$on('open-menu-mobile', values => {
        this.show = values.show
      })
    },
    computed: {
      ...mapGetters(['user'])
    },
    created () {
      if (this.$store.getters.jwt.token !== null) {
        this.ed = this.$ws
        .withJwtToken(this.$store.getters.jwt.token.substr(7))
        .connect()
        .subscribe('notifications')
      }
    }
  }
</script>

<template lang="pug">
aside.right_menu
  .menu-app
    .slim_scroll
      .card
        .header
          h2
            strong App
            |
            | Menu
        .body
          ul.list-unstyled.menu
            li
              a(href="events.html")
                i.zmdi.zmdi-calendar-note
                span Calendar
            li
              a(href="file-dashboard.html")
                i.zmdi.zmdi-file-text
                span File Manager
            li
              a(href="blog-dashboard.html")
                i.zmdi.zmdi-blogger
                span Blog
            li
              a(href="javascript:void(0)")
                i.zmdi.zmdi-arrows
                span Notes
            li
              a(href="javascript:void(0)")
                i.zmdi.zmdi-view-column
                span Taskboard
  .notif-menu
    .slim_scroll
      .card
        .header
          h2
            strong Messages
        .body
          ul.messages.list-unstyled
            li
              a(href="javascript:void(0);")
                .media
                  img.media-object.rounded-circle(
                    src="/static/images/xs/avatar1.jpg",
                    alt=""
                  )
                  .media-body
                    span.name
                      | Alexander
                      small.time 35min ago
                    p.message New tasks needs to be done
            li
              a(href="javascript:void(0);")
                .media
                  img.media-object.rounded-circle(
                    src="/static/images/xs/avatar2.jpg",
                    alt=""
                  )
                  .media-body
                    span.name
                      | Grayson
                      small.time 1hr ago
                    p.message New tasks needs to be done
            li
              a(href="javascript:void(0);")
                .media
                  img.media-object.rounded-circle(
                    src="/static/images/xs/avatar3.jpg",
                    alt=""
                  )
                  .media-body
                    span.name
                      | Sophia
                      small.time 31min ago
                    p.message New tasks needs to be done
      .card
        .header
          h2
            strong Notifications
        .body
          ul.notification.list-unstyled
            li
              i.zmdi.zmdi-balance-wallet.text-success
              strong +$30 New sale
              p
                a(href="javascript:void(0)") Admin Template
              small.text-muted 7 min ago
            li
              i.zmdi.zmdi-edit.text-info
              strong You Edited file
              p
                a(href="javascript:void(0)") Docs.doc
              small.text-muted 15 min ago
            li
              i.zmdi.zmdi-delete.text-danger
              strong Project removed
              p
                a(href="javascript:void(0)") AdminX BS4
              small.text-muted 1 hours ago
            li
              i.zmdi.zmdi-account.text-success
              strong New user
              p
                a(href="javascript:void(0)") UI Designer
              small.text-muted 1 hours ago
            li
              i.zmdi.zmdi-flag.text-warning
              strong Alpino v1.0.0 is available
              p
                a(href="javascript:void(0)") Update now
              small.text-muted 5 hours ago
  .task-menu
    .slim_scroll
      .card.tasks
        .header
          h2
            strong Project
            |
            | Status
        .body.m-b-10
          a(href="javascript:void(0);")
            span.text-muted
              | Project Name 1
              span.float-right 29%
            .progress
              .progress-bar.l-turquoise(
                role="progressbar",
                aria-valuenow="29",
                aria-valuemin="0",
                aria-valuemax="100",
                style="width: 29%;"
              )
            ul.list-unstyled.team-info
              li.m-r-15
                small.text-muted Team
              li
                img(src="/static/images/xs/avatar2.jpg", alt="Avatar")
              li
                img(src="/static/images/xs/avatar3.jpg", alt="Avatar")
              li
                img(src="/static/images/xs/avatar4.jpg", alt="Avatar")
        .body.m-b-10
          a(href="javascript:void(0);")
            span.text-muted
              | Project Name 2
              span.float-right 78%
            .progress
              .progress-bar.l-slategray(
                role="progressbar",
                aria-valuenow="78",
                aria-valuemin="0",
                aria-valuemax="100",
                style="width: 78%;"
              )
            ul.list-unstyled.team-info
              li.m-r-15
                small.text-muted Team
              li
                img(src="/static/images/xs/avatar6.jpg", alt="Avatar")
              li
                img(src="/static/images/xs/avatar7.jpg", alt="Avatar")
        .body
          a(href="javascript:void(0);")
            span.text-muted
              | Project Name 4
              span.float-right 68%
            .progress
              .progress-bar.l-coral(
                role="progressbar",
                aria-valuenow="68",
                aria-valuemin="0",
                aria-valuemax="100",
                style="width: 68%;"
              )
            ul.list-unstyled.team-info
              li.m-r-15
                small.text-muted Team
              li
                img(src="/static/images/xs/avatar8.jpg", alt="Avatar")
              li
                img(src="/static/images/xs/avatar9.jpg", alt="Avatar")
  #rightsidebar.right-sidebar
    ul.nav.nav-tabs
      li.nav-item
        a.nav-link.active(data-toggle="tab", href="#setting") Setting
      li.nav-item
        a.nav-link(data-toggle="tab", href="#activity") Activity
    .tab-content.slim_scroll
      #setting.tab-pane.slideRight.active
        .card
          .header
            h2
              strong Colors
              |
              | Skins
          .body
            ul.choose-skin.list-unstyled.m-b-0
              li.active(data-theme="black")
                .black
              li(data-theme="purple")
                .purple
              li(data-theme="blue")
                .blue
              li(data-theme="cyan")
                .cyan
              li(data-theme="green")
                .green
              li(data-theme="orange")
                .orange
              li(data-theme="blush")
                .blush
        .card
          .header
            h2
              strong General
              |
              | Settings
          .body
            ul.setting-list.list-unstyled.m-b-0
              li
                .checkbox
                  input#checkbox1(type="checkbox")
                  label(for="checkbox1") Report Panel Usage
              li
                .checkbox
                  input#checkbox2(type="checkbox", checked="")
                  label(for="checkbox2") Email Redirect
              li
                .checkbox
                  input#checkbox3(type="checkbox")
                  label(for="checkbox3") Notifications
              li
                .checkbox
                  input#checkbox4(type="checkbox")
                  label(for="checkbox4") Auto Updates
              li
                .checkbox
                  input#checkbox5(type="checkbox", checked="")
                  label(for="checkbox5") Offline
              li
                .checkbox.m-b-0
                  input#checkbox6(type="checkbox")
                  label(for="checkbox6") Location Permission
        .card
          .header
            h2
              strong Left
              |
              | Menu
          .body.theme-light-dark
            button.t-dark.btn.btn-primary.btn-round.btn-block Dark
      #activity.tab-pane.slideLeft
        .card.activities
          .header
            h2
              strong Recent
              |
              | Activity Feed
          .body
            .streamline.b-accent
              .sl-item
                .sl-content
                  .text-muted Just now
                  p
                    | Finished task
                    a.text-info(href="") #features 4
                    | .
              .sl-item.b-info
                .sl-content
                  .text-muted 10:30
                  p
                    a(href="") @Jessi
                    |
                    | retwit your post
              .sl-item.b-primary
                .sl-content
                  .text-muted 12:30
                  p
                    | Call to customer
                    a.text-info(href="") Jacob
                    |
                    | and discuss the detail.
              .sl-item.b-warning
                .sl-content
                  .text-muted 1 days ago
                  p
                    a.text-info(href="") Jessi
                    |
                    | commented your post.
              .sl-item.b-primary
                .sl-content
                  .text-muted 2 days ago
                  p
                    | Call to customer
                    a.text-info(href="") Jacob
                    |
                    | and discuss the detail.
              .sl-item.b-primary
                .sl-content
                  .text-muted 3 days ago
                  p
                    | Call to customer
                    a.text-info(href="") Jacob
                    |
                    | and discuss the detail.
              .sl-item.b-warning
                .sl-content
                  .text-muted 4 Week ago
                  p
                    a.text-info(href="") Jessi
                    |
                    | commented your post.
              .sl-item.b-warning
                .sl-content
                  .text-muted 5 days ago
                  p
                    a.text-info(href="") Jessi
                    |
                    | commented your post.
              .sl-item.b-primary
                .sl-content
                  .text-muted 5 Week ago
                  p
                    | Call to customer
                    a.text-info(href="") Jacob
                    |
                    | and discuss the detail.
              .sl-item.b-primary
                .sl-content
                  .text-muted 3 Week ago
                  p
                    | Call to customer
                    a.text-info(href="") Jacob
                    |
                    | and discuss the detail.
              .sl-item.b-warning
                .sl-content
                  .text-muted 1 Month ago
                  p
                    a.text-info(href="") Jessi
                    |
                    | commented your post.
  #leftsidebar.sidebar.scrollbar(
    v-if="mobile",
    style="overflow-y: scroll; z-index: 8;",
    :class="{ 'open stretchRight': show }"
  )
    .menu
      ul.list
        li
          .user-info.m-b-20
            .image(@click.prevent="closeMenuMobile()")
              router-link(:to="{ name: 'dweller.profile.overview.me' }")
                img(:src="user.image", alt="User", v-if="user.image !== null")
                img(
                  src="/static/images/profile_av.jpeg",
                  alt="User",
                  v-if="user.image === null"
                )
            .detail
              h6 {{ user.name }}
        li.header PRINCIPAL
        li(
          :class="{ 'active open': menu === 'dashboard' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('dashboard')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.dashboard.index' }")
            i.zmdi.zmdi-home
            span Dashboard

        li(
          :class="{ 'active open': menu === 'unit' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('unit')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.unit.index' }")
            i.zmdi.zmdi-balance
            span Unidades

        li(
          :class="{ 'active open': menu === 'moving' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('moving')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.moving.index' }")
            i.zmdi.zmdi-truck
            span Mudança

        li(
          :class="{ 'active open': menu === 'car' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('car')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.car.index' }")
            i.zmdi.zmdi-car
            span Veículos

        li(
          :class="{ 'active open': menu === 'parking' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('parking')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.parking.index' }")
            i.zmdi.zmdi-swap
            span Empréstimo de vagas

        li(
          :class="{ 'active open': menu === 'bike' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('bike')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.bike.index' }")
            i.zmdi.zmdi-bike
            span Bicicletas

        li(
          :class="{ 'active open': menu === 'occurrence' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('occurrence')"
        )
          router-link.menu-toggle(
            :to="{ name: 'dweller.book.occurrence.index' }"
          )
            i.zmdi.zmdi-bookmark
            span Livro Ocorrência

        li(
          :class="{ 'active open': menu === 'rental' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('rental')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.rental.unit.index' }")
            i.zmdi.zmdi-key
            span Locação de Unidade

        li(
          :class="{ 'active open': menu === 'rent-parking' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('rent-parking')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.rent.parking.index' }")
            i.zmdi.zmdi-money-box
            span Locação de Vagas

        li(
          :class="{ 'active open': menu === 'files' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('files')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.files.index' }")
            i.zmdi.zmdi-attachment-alt
            span Arquivos

        li(
          :class="{ 'active open': menu === 'accountability' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('accountability')"
        )
          router-link.menu-toggle(
            :to="{ name: 'dweller.accountability.index' }"
          )
            i.zmdi.zmdi-money
            span Prestação de Contas

        li(
          :class="{ 'active open': menu === 'meetings' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('meetings')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.meetings.index' }")
            i.zmdi.zmdi-library
            span Assembléias

        li(
          :class="{ 'active open': menu === 'guest' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('guest')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.guest.index' }")
            i.zmdi.zmdi-accounts-list-alt
            span Lista Convidados

        li(
          :class="{ 'active open': menu === 'area' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('area')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.common-area.index' }")
            i.zmdi.zmdi-store
            span Áreas Comnuns
        li(
          :class="{ 'active open': menu === 'control' }",
          @click.prevent="closeMenuMobile('control', true)"
        )
          a.menu-toggle.waves-effect.waves-block.toggled(
            href="javascript:void(0);"
          )
            i.zmdi.zmdi-walk
            span Controle de Acesso

          ul.ml-menu(style="display: block;", v-if="menu === 'control'")
            li(@click.prevent="closeMenuMobile('control', false)")
              router-link.waves-effect.waves-block(
                :to="{ name: 'dweller.visitor.index' }"
              )
                | Cadastro

            li(@click.prevent="closeMenuMobile('control', false)")
              router-link.waves-effect.waves-block(
                :to="{ name: 'dweller.access.index' }"
              )
                | Liberar Acesso

        li(
          :class="{ 'active open': menu === 'living' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('living')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.livings.index' }")
            i.zmdi.zmdi-accounts-add
            span Residem no Local

        li(
          :class="{ 'active open': menu === 'pet' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('pet')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.pets.index' }")
            i.zmdi.zmdi-github-alt
            span Pets
  //- Nao Mobile
  #leftsidebar.sidebar.scrollbar(
    v-if="!mobile",
    style="overflow-y: scroll;",
    :class="{ 'open stretchRight': show }"
  )
    .menu
      ul.list
        li
          .user-info.m-b-20
            .image(@click.prevent="closeMenuMobile()")
              router-link(:to="{ name: 'dweller.profile.me.me' }")
                img(:src="user.image", alt="User", v-if="user.image !== null")
                img(
                  src="/static/images/profile_av.jpeg",
                  alt="User",
                  v-if="user.image === null"
                )
            .detail
              h6 {{ user.name }}
        li.header PRINCIPAL
        li(
          :class="{ 'active open': menu === 'dashboard' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('dashboard')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.dashboard.index' }")
            i.zmdi.zmdi-home
            span Dashboard

        li(
          :class="{ 'active open': menu === 'unit' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('unit')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.unit.index' }")
            i.zmdi.zmdi-balance
            span Unidades

        li(
          :class="{ 'active open': menu === 'moving' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('moving')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.moving.index' }")
            i.zmdi.zmdi-truck
            span Mudança

        li(
          :class="{ 'active open': menu === 'car' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('car')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.car.index' }")
            i.zmdi.zmdi-car
            span Veículos

        li(
          :class="{ 'active open': menu === 'parking' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('parking')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.parking.index' }")
            i.zmdi.zmdi-swap
            span Empréstimo de vagas

        li(
          :class="{ 'active open': menu === 'bike' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('bike')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.bike.index' }")
            i.zmdi.zmdi-bike
            span Bicicletas

        li(
          :class="{ 'active open': menu === 'occurrence' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('occurrence')"
        )
          router-link.menu-toggle(
            :to="{ name: 'dweller.book.occurrence.index' }"
          )
            i.zmdi.zmdi-bookmark
            span Livro Ocorrência

        li(
          :class="{ 'active open': menu === 'rental' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('rental')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.rental.unit.index' }")
            i.zmdi.zmdi-key
            span Locação de Unidade

        li(
          :class="{ 'active open': menu === 'rent-parking' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('rent-parking')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.rent.parking.index' }")
            i.zmdi.zmdi-money-box
            span Locação de Vagas

        li(
          :class="{ 'active open': menu === 'files' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('files')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.files.index' }")
            i.zmdi.zmdi-attachment-alt
            span Arquivos

        li(
          :class="{ 'active open': menu === 'accountability' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('accountability')"
        )
          router-link.menu-toggle(
            :to="{ name: 'dweller.accountability.index' }"
          )
            i.zmdi.zmdi-money
            span Prestação de Contas

        li(
          :class="{ 'active open': menu === 'meetings' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('meetings')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.meetings.index' }")
            i.zmdi.zmdi-library
            span Assembléias

        li(
          :class="{ 'active open': menu === 'control' }",
          @click.prevent="closeMenuMobile('control', true)"
        )
          a.menu-toggle.waves-effect.waves-block.toggled(
            href="javascript:void(0);"
          )
            i.zmdi.zmdi-walk
            span Controle de Acesso

          ul.ml-menu(style="display: block;", v-if="menu === 'control'")
            li(@click.prevent="closeMenuMobile('control', false)")
              router-link.waves-effect.waves-block(
                :to="{ name: 'dweller.visitor.index' }"
              )
                | Cadastro

            li(@click.prevent="closeMenuMobile('control', false)")
              router-link.waves-effect.waves-block(
                :to="{ name: 'dweller.access.index' }"
              )
                | Liberar Acesso
        li(
          :class="{ 'active open': menu === 'guest' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('guest')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.guest.index' }")
            i.zmdi.zmdi-accounts-list-alt
            span Lista Convidados

        li(
          :class="{ 'active open': menu === 'area' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('area')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.common-area.index' }")
            i.zmdi.zmdi-store
            span Áreas Comnuns

        li(
          :class="{ 'active open': menu === 'living' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('living')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.livings.index' }")
            i.zmdi.zmdi-walk
            span Residem no Local

        li(
          :class="{ 'active open': menu === 'pet' }",
          style="cursor: pointer",
          @click.prevent="closeMenuMobile('pet')"
        )
          router-link.menu-toggle(:to="{ name: 'dweller.pets.index' }")
            i.zmdi.zmdi-github-alt
            span Pets
            
        li
</template>
<style scoped>
.none-display {
  display: none;
}
.block-display {
  display: block;
}
.scrollbar {
  float: left;
  background: #f5f5f5;
  overflow-y: scroll;
  margin-bottom: 25px;
}
#leftsidebar::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

#leftsidebar::-webkit-scrollbar {
  width: 0px;
  background-color: #f5f5f5;
}

#leftsidebar::-webkit-scrollbar-thumb {
  background-color: #000000;
  border: 1px solid #555555;
}
</style>



// WEBPACK FOOTER //
// src/layout/menu-aside.vue